'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = function Option(_ref) {
    var selected = _ref.selected,
        className = _ref.className,
        children = _ref.children,
        label = _ref.label,
        value = _ref.value,
        disabled = _ref.disabled;
    return _react2.default.createElement("option", { selected: selected, className: className && (0, _classnames2.default)(className), value: (0, _utils.stringify)(value), label: label }, children);
};
Option.propTypes = {
    value: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number]),
    label: _propTypes2.default.node,
    onChange: _propTypes2.default.func,
    selected: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object])
};
exports.default = Option;
//# sourceMappingURL=Option.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Option/Option.js